import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { EnrollmentsCategoriesRedux } from '../Redux/EnrollmentsCategoriesRedux'

const enrollmentsCategoriesCrudObservable = createCRUDObservable({
  mainRedux: EnrollmentsCategoriesRedux,
  reduxPath: 'enrollmentsCategories',
  dataHandlers: {
    get: response => response.data,
  },
})

export const enrollmentsCategoriesObservers = Object.assign({}, enrollmentsCategoriesCrudObservable.observers, {})

export const enrollmentsCategoriesEpic = combineEpics(
  enrollmentsCategoriesCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/EnrollmentsCategoriesObservable.js